import { useState } from 'react';
import { Button } from 'reactstrap';
import { BiLock } from 'react-icons/bi';
import useTierFeatures from '../../hooks/useTierFeatures';
import useBillingUsage from '../../hooks/useBillingUsage';
import useIsOrgAdmin from '../../hooks/useIsOrgAdmin';
import ChangePlanModal from '../billing/ChangePlanModal';
import InsightCard from './InsightCard';

export default function InsightsLockedTeaser({ teaserInsights }) {
    const { tier, isLoading } = useTierFeatures();
    const { data: usage } = useBillingUsage();
    const isAdmin = useIsOrgAdmin();
    const [planModalOpen, setPlanModalOpen] = useState(false);

    if (isLoading) return null;
    // Business tier users should never see this — caller should guard, but
    // defence-in-depth.
    if (tier === 'business') return null;

    const teaser = teaserInsights?.[0] ?? {
        title: 'You may be under-pricing kitchen jobs',
        body: 'Upgrade to Business to unlock AI-powered insights across all your jobs and dashboard.',
        category: 'Margin',
        severity: 'warning',
    };

    return (
        <div className="position-relative mb-4">
            {/* Blurred teaser card behind the overlay */}
            <div style={{ filter: 'blur(4px)', pointerEvents: 'none', userSelect: 'none' }}>
                <InsightCard {...teaser} />
            </div>

            {/* Gradient overlay with CTA */}
            <div
                className="position-absolute top-0 start-0 w-100 h-100 d-flex flex-column align-items-center justify-content-center"
                style={{
                    background: 'linear-gradient(180deg, rgba(var(--bs-body-bg-rgb, 255,255,255), 0.6) 0%, rgba(var(--bs-body-bg-rgb, 255,255,255), 0.95) 100%)',
                    borderRadius: 'inherit',
                }}
            >
                <BiLock size={28} className="text-muted mb-2" />
                <p className="fw-semibold mb-2 text-center" style={{ fontSize: '0.95rem' }}>
                    AI Insights are available on the Business plan
                </p>
                {/* Admins get the upgrade modal directly. Non-admins can't
                    change plan (server enforces AdminOnly on /Billing/ChangeTier),
                    so a button would 403 — surface the right path instead. */}
                {isAdmin ? (
                    <Button color="primary" size="sm" onClick={() => setPlanModalOpen(true)}>
                        Upgrade to Business
                    </Button>
                ) : (
                    <p className="text-muted small mb-0">Ask an admin to upgrade your plan.</p>
                )}
            </div>

            {isAdmin && usage && (
                <ChangePlanModal
                    isOpen={planModalOpen}
                    toggle={() => setPlanModalOpen(false)}
                    currentTier={usage.tier}
                    pendingTier={usage.pendingTier}
                />
            )}
        </div>
    );
}
